import React, { useState, useLayoutEffect, useContext } from 'react';

import * as S from './styles';
import SimpleInput from 'components/SimpleInput';
import InputColor from 'components/InputColor';
import DynamicPageContext from 'context/DynamicPage';
import { verifyIfFormCanSave } from './functions';
import SelectInput from 'components/SelectInput';
import { optionsRedirectType } from 'utils/optionsInputs';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { returListOptionsDynamicPage } from './functions';

export interface DataInputsHighlightBarProps {
	text: string;
	redidrectType: string;
	redidrectValue: string;
	textColor: string;
	backgroundColor: string;
}

const initialState: DataInputsHighlightBarProps = {
	text: '',
	redidrectType: '',
	redidrectValue: '',
	textColor: '#000',
	backgroundColor: '#fff'
};

export default function InputsHighlightBar() {
	const {
		dynamicPagesList,
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		moduleOnPhoneToEdit,
		setModuleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [dataForm, setDataForm] =
		useState<DataInputsHighlightBarProps>(initialState);
	const [optionsDynamicScreen, setOptionsDynamicScreen] = useState<
		SelectInputItemProps[]
	>([]);

	function findOptionOnListById(value: string, list: SelectInputItemProps[]) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	function findeOptionOnListByNumber(
		value: string,
		list: SelectInputItemProps[]
	) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	//cria lista de opções de pagínas dinamicas em um estado para evitar reenderização
	useLayoutEffect(() => {
		setOptionsDynamicScreen(returListOptionsDynamicPage(dynamicPagesList));
	}, []);

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		setTimeout(() => {
			if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}
		}, 100);
	}, []);

	return (
		<S.container>
			<SimpleInput
				label="Título *"
				initialValue={dataForm.text}
				getValue={(value: string) => {
					setDataForm((obj) => ({ ...obj, text: value }));
				}}
			/>

			<SelectInput
				list={optionsRedirectType}
				getValue={(value: SelectInputItemProps | '') => {
					setDataForm((obj) => ({
						...obj,
						redidrectType: value === '' ? value : (value?.id as string)
					}));
				}}
				initialValue={
					dataForm.redidrectType === ''
						? ''
						: findeOptionOnListByNumber(
								dataForm.redidrectType || '',
								optionsRedirectType
							)
				}
				label="Tipo de redirecionamento"
			/>

			{(dataForm.redidrectType === '' ||
				dataForm.redidrectType === 'product' ||
				dataForm.redidrectType === 'url' ||
				dataForm.redidrectType === 'webview' ||
				dataForm.redidrectType === 'query' ||
				dataForm.redidrectType === 'screen_app') && (
				<SimpleInput
					label="Valor Redirecionamento"
					initialValue={dataForm.redidrectValue}
					getValue={(value: string) => {
						setDataForm((obj) => ({
							...obj,
							redidrectValue: value
						}));
					}}
				/>
			)}

			{dataForm.redidrectType === 'app_screen' && (
				<SelectInput
					list={optionsDynamicScreen}
					getValue={(value: SelectInputItemProps | '') => {
						setDataForm((obj) => ({
							...obj,
							redidrectValue: value === '' ? value : (value?.id as string)
						}));
					}}
					initialValue={
						dataForm.redidrectValue === ''
							? ''
							: findOptionOnListById(
									dataForm.redidrectValue || '',
									optionsDynamicScreen
								)
					}
					label="Valor Redirecionamento *"
				/>
			)}

			<InputColor
				rgbOrExadecimal={false}
				label="Cor do texto"
				value={dataForm.textColor}
				setValue={(value: string) => {
					setDataForm((obj) => ({ ...obj, textColor: value }));
				}}
			/>

			<InputColor
				rgbOrExadecimal={false}
				label="Cor de fundo"
				value={dataForm.backgroundColor}
				setValue={(value: string) => {
					setDataForm((obj) => ({ ...obj, backgroundColor: value }));
				}}
			/>
		</S.container>
	);
}
